import * as React from 'react';
import { Query } from 'react-apollo';
import type { QueryResult } from 'react-apollo';

import type { ReactRenderPropsComponent } from '../../../lib/types';
import GetAdminUserProfilesQueryDocument from './graphql/GetAdminUserProfiles.graphql';
import type {
  GetAdminUserProfilesQuery,
  GetAdminUserProfilesQueryVariables,
} from './graphql/__generated__/GetAdminUserProfiles';

interface Props {
  userId: string;
}

export type GetAdminUserProfilesQueryResult = QueryResult<
  GetAdminUserProfilesQuery,
  GetAdminUserProfilesQueryVariables
>;

const AdminUserProfilesProvider: ReactRenderPropsComponent<GetAdminUserProfilesQueryResult, Props> = ({
  userId,
  children,
}) => (
  <Query<GetAdminUserProfilesQuery, GetAdminUserProfilesQueryVariables>
    query={GetAdminUserProfilesQueryDocument}
    context={{ clientName: 'gatewayGql' }}
    variables={{ input: { userId } }}
  >
    {children}
  </Query>
);

export default AdminUserProfilesProvider;
